import Foundation from 'foundation-sites/dist/js/foundation';

// var createFocusTrap = require('focus-trap'); // https://github.com/davidtheclark/focus-trap/issues/30
import * as focusModuleTrap from 'focus-trap';

import CookieConsentApi from "../../organisms/cookie-consent/cookie-consent-api";

let time; // Set for timeout function.
let linkWidth; // Store width for link items.
const $body = $('body');
const $element = $('.navigation');
const $navigationOpenButton = $('.header__navigation__button');
const $navigationCloseButton = $element.find('.navigation__close__button');
const $navigationListItem = $element.find('.navigation__primary__list__item');
const $navigationListItemLink = $element.find('.navigation__primary__list__item__link');
const $navigationLitSubmenu = $element.find('.navigation__primary__sublist');
const $navigationBackground = $element.find('.navigation__background');
const $navigationOpenSubnavigation = $element.find('.navigation__primary__list__item__sublist-open');

const focusTrap = focusModuleTrap.createFocusTrap('#menu');

// This calculates the width to sub navigation to indicate position value.
const calculateWidth = () => {
  if (window.matchMedia('(min-width: 1300px)').matches) {
    return;
  }
  const width = Math.max.apply(null, $($navigationListItemLink).map(function () {
      return $(this).outerWidth(true);
  }).get() );

  linkWidth = width + 30;

  $navigationListItem.css('max-width', linkWidth);
}

// Mobile handler.
const mobileToggleClickHandler = (event) => {
  if  (!$(event.target).parent($navigationListItem).hasClass('active')
      && ($(event.target).parent().find($navigationLitSubmenu).length !== 0)
      && !Foundation.MediaQuery.atLeast('xxlarge')) {

        event.preventDefault();
        $navigationListItemLink.not(event.target).parent($navigationListItem).removeClass('active');
        $(event.target).parent($navigationListItem).addClass('active');
        $(event.target).attr('aria-expanded', 'true');
  } else {
    $(event.target).attr('aria-expanded', 'false');
  }
}

// Desktop focus enter to open subnavigation from parent link
const desktopFocusHandler = (event) => {
    $navigationListItemLink.not($(event.target)).parent($navigationListItem).removeClass('active-desktop');
    $(event.target).parent($navigationListItem).addClass('active-desktop');
    $(event.target).attr('aria-expanded', 'true');
}

const desktopFocusListItemHandler = () => {
  $navigationListItem.removeClass('active-desktop');
  $navigationListItemLink.attr('aria-expanded', 'false');
}

// Desktop hover enter over link with subnavigation
const desktopHoverHandler = (event) => {
  if(Foundation.MediaQuery.atLeast('xxlarge')) {
    $navigationListItemLink.not($(event.target)).parent($navigationListItem).removeClass('active-desktop');
    $(event.target).parent($navigationListItem).addClass('active-desktop');
    $(event.target).attr('aria-expanded', 'true');
  }
}

// Desktop leave mouse over.
const desktopMouseOverHandler = (event) => {
  if(Foundation.MediaQuery.atLeast('xxlarge') && $(event.target).parents('.active-desktop').length) {
    clearTimeout(time)
  }
}

// Desktop hover leave over link with subnavigation
const desktopMouseOutHandler = () => {
  if(Foundation.MediaQuery.atLeast('xxlarge')) {
    clearTimeout(time);

    time = setTimeout(function () {
      $navigationListItem.removeClass('active-desktop');
      $navigationListItemLink.attr('aria-expanded', 'false');
    }, 500)
  }
};

const openNavigation = () => {
  $element.toggleClass('navigation--visible');
  $element.removeClass('navigation--hidden');
  $body.addClass('scroll-lock');
  $element.attr('aria-hidden', 'false');
  $navigationOpenButton.attr('aria-expanded', 'true');

  const cookieConsent = CookieConsentApi.get();
  if (cookieConsent === null || cookieConsent['cookie-consent'] === true) { // null when CC is not active in Epi
    focusTrap.activate();
  }

  calculateWidth();
  document.dispatchEvent(new CustomEvent('main-menu-open'));
}

const closeNavigation = () => {
  $element.toggleClass('navigation--hidden');
  $element.removeClass('navigation--visible');
  $body.removeClass('scroll-lock');
  $element.attr('aria-hidden', 'true');
  $navigationOpenButton.attr('aria-expanded', 'false');
  focusTrap.deactivate();
  document.dispatchEvent(new CustomEvent('main-menu-close'));
}

const events = () => {
  $navigationListItemLink.on('touchstart click mouseenter', mobileToggleClickHandler);
  $navigationListItemLink.bind('mouseenter', desktopHoverHandler);
  $navigationListItemLink.on('focus', desktopFocusListItemHandler);
  $navigationOpenSubnavigation.on('click', desktopFocusHandler);

  $navigationListItem.on('mouseout', desktopMouseOutHandler).on('mouseover', desktopMouseOverHandler);

  $navigationOpenButton.on('click', openNavigation);
  $navigationCloseButton.on('click', closeNavigation);
  $navigationBackground.on('click', closeNavigation);

}

const init = () => {
  events();
}

export default init;